import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { typePaginationDashboardObject } from '../DashboardContentTable/PaginationDashboard/PaginationDashboard'
import { useInputChange } from 'hooks/useInputChange'
import { IdCashDesksState, typeCashDesksFilters } from 'model/dashboardCashDesks/dCashDesksReducer'
import {
    dCashDesksClearFiltersAC,
    dCashDesksSetDataSagaAC, dCashDesksSetFiltersAC, dCashDesksSetItemsForPageAC,
    dCashDesksSetPageNumberAC
} from 'model/dashboardCashDesks/dCashDesksActionCreators'
import { ViewDataCashDesks } from 'components/containers/dashboard/dataCashDesk/ViewComponent'


// Type
export type typeDataCashDesks = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
}



// Component
export const DataCashDesks: React.FC<typeDataCashDesks> = ({ variant, setSidebarOpen }) => {

    const dispatch = useDispatch()

    // DateFilter
    const [isActiveFilters, setIsActiveFilters] = useState(false)
    const filters = useSelector((state: { dCashDesks: IdCashDesksState }) => state.dCashDesks.filters)
    const [ openFilterBar, setOpenFilterBar ] = useState(false)

    /// Pagination
    const pagination: typePaginationDashboardObject = {
        paginationObject: useSelector((state: { dCashDesks: IdCashDesksState }) => state.dCashDesks.pagination),
        onGoToPage: (id) => dispatch(dCashDesksSetPageNumberAC(id)),
        onSelectItems: (itemsPerPage) => dispatch(dCashDesksSetItemsForPageAC(itemsPerPage))
    }



    // Did mount & Did unmount
    useEffect(() => {

        return () => {
            dispatch(dCashDesksClearFiltersAC())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        dispatch(dCashDesksSetDataSagaAC(
            filters,
            { page: pagination.paginationObject.pageNumber, size: pagination.paginationObject.itemsPerPage! }
        ))
// eslint-disable-next-line
    }, [ filters, pagination.paginationObject.pageNumber,pagination.paginationObject.itemsPerPage ])

    // Search panel

    const searchName = useSelector((state: { dCashDesks: IdCashDesksState }) => state.dCashDesks.filters?.storeName)

    const {
        value: searchValue,
        setValue: setSearchValue,
        changeValueHandler: onChangeSearchValue
    } = useInputChange(searchName || '')

    const onClearSearch = () => {
        dispatch(dCashDesksSetFiltersAC({
                                            storeName: null
                                        }))

        setSearchValue('')
    }
    const onEnterSearch = () => {

        const filters: typeCashDesksFilters = {

            storeName: searchValue.trim()
        }
        dispatch(dCashDesksSetFiltersAC(filters))

    }

    // Popup details
    const [openPopupDetails, setOpenPopupDetails] = useState(false)

    const currentItem = useSelector((state: { dCashDesks: IdCashDesksState }) => state.dCashDesks.detailItem)

    return (
        <ViewDataCashDesks
            variant={ variant }
            setSidebarOpen={ setSidebarOpen }

            openFilterBar={ openFilterBar }
            setOpenFilterBar={ setOpenFilterBar }

            openPopupDetails={openPopupDetails}
            setOpenPopupDetails={setOpenPopupDetails}

            searchValue={ searchValue }
            onChangeSearchValue={ onChangeSearchValue }
            onClearSearch={ onClearSearch }
            onEnterSearch={ onEnterSearch }

            currentItem={ currentItem }

            pagination={ pagination }
            isActiveFilters={isActiveFilters}
            setIsActiveFilters={setIsActiveFilters}
        />

    )
}
